<div class="macro-modal d-flex flex-column">
    <div class="close d-flex justify-content-end">
        <i class="btn-close icon-edponline-Bop-071" (click)="closeModal(false)" aria-hidden="true"></i>
    </div>
    <img class="w-100 macro-challenge-image" src="{{ macroImage }}" alt="macro-challenge-image" />
    <div class="macro-info">
        <h1 class="title">
            {{'pt.edp.edponline.dashboard.section.macro.modal.congrats' | translate}}
            <img class="icon-title" src="assets/images/medal.png" alt="medal-icon">
        </h1>
        <div class="description">
            <span [innerHTML]="'pt.edp.edponline.dashboard.section.macro.modal.description' | translate"></span>
        </div>
    </div>
</div>
